import request from '../utils/request';

/**
 * 获取用户等级分页列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回请求结果
 */
export function getUserLevelList(params) {
  return request({
    url: '/user-levels/list',
    method: 'get',
    params
  });
} 